const flatbuffers = require('flatbuffers')

const ActualFbGenerator = require('../lib/js/sportsbook/actual.js')
const TreeFbGenerator = require('../lib/js/sportsbook/tree.js')

const h = require('./_help.decode')

module.exports = function decodeSbActual ({ binaryActual }) {
  const enumDecoder = h.createEnumDecoder(ActualFbGenerator)
  const treeEnumDecoder = h.createEnumDecoder(TreeFbGenerator)

  const actualByteBuffer = new flatbuffers.ByteBuffer(binaryActual)

  const root = ActualFbGenerator.Actual.getRootAsActual(actualByteBuffer)

  const sports = h.bmap(root, 'sports', bSport => ({
    'sbId': bSport.sbId(),
    'customId': bSport.customId(),
    'name': bSport.name(),
    'state': bSport.state(),
    'weight': bSport.weight(),
    'sportEventsNumber': bSport.sportEventsNumber(),
    'liveSportEventsNumber': bSport.liveSportEventsNumber(),
    'sbType': treeEnumDecoder('SbType', bSport.sbType()),
    'matchStatuses': h.bmap(bSport, 'matchStatuses', bMatchStatus => ({
      'description': bMatchStatus.description(),
      'period_number': bMatchStatus.periodNumber(),
      'state': bMatchStatus.state(),
      'abbreviation': bMatchStatus.abbreviation(),
      'status': bMatchStatus.status(),
    })),
  }))

  const categories = h.bmap(root, 'categories', bCategory => ({
    'sbId': bCategory.sbId(),
    'customId': bCategory.customId(),
    'name': bCategory.name(),
    'state': bCategory.state(),
    'weight': bCategory.weight(),
    'sbSportId': bCategory.sbSportId(),
    'customSportId': bCategory.customSportId(),
    'countryCode': bCategory.countryCode() || undefined,
    'sportEventsNumber': bCategory.sportEventsNumber(),
    'liveSportEventsNumber': bCategory.liveSportEventsNumber(),
    'sbType': treeEnumDecoder('SbType', bCategory.sbType()),
  }))

  const tournaments = h.bmap(root, 'tournaments', bTournament => ({
    'sbId': bTournament.sbId(),
    'customId': bTournament.customId(),
    'name': bTournament.name(),
    'state': bTournament.state(),
    'weight': bTournament.weight(),
    'sbCategoryId': bTournament.sbCategoryId(),
    'customCategoryId': bTournament.customCategoryId(),
    'image': bTournament.image(),
    'sportEventsNumber': bTournament.sportEventsNumber(),
    'liveSportEventsNumber': bTournament.liveSportEventsNumber(),
    'top': bTournament.top(),
    'sbType': treeEnumDecoder('SbType', bTournament.sbType()),
  }))

  const sportEvents = h.bmap(root, 'sportEvents', bSportEvent => ({
    'id': bSportEvent.id(),
    'state': bSportEvent.state(),
    'status': bSportEvent.status(),
    'weight': bSportEvent.weight(),
    'type': enumDecoder('SportEventType', bSportEvent.type()),
    'se_type': enumDecoder('SportEventSeType', bSportEvent.seType()),
    'provider': bSportEvent.provider(),
    'sport_id': bSportEvent.sportId(),
    'category_id': bSportEvent.categoryId(),
    'tournament_id': bSportEvent.tournamentId(),
    'liveodds': enumDecoder('SportEventLiveOdds', bSportEvent.liveodds()),
    'scheduled': parseInt(bSportEvent.scheduled(), 10),
    'timestamp': parseInt(bSportEvent.timestamp(), 10),
    'activeMarketsCount': bSportEvent.activeMarketsCount(),
    'tournament_round_type': bSportEvent.tournamentRoundType() || null,
    'tournament_round_level': bSportEvent.tournamentRoundLevel() || null,
    'tournament_round_number': bSportEvent.tournamentRoundNumber() || null,
    'competitors': h.bmap(bSportEvent, 'competitors', bCompetitor => ({
      'id': bCompetitor.id(),
      'name': bCompetitor.name(),
      'state': bCompetitor.state(),
      'img': {
        'small': bCompetitor.imageSmall(),
        'medium': bCompetitor.imageMedium(),
        'big': bCompetitor.imageBig(),
      },
      'qualifier': enumDecoder('CompetitorQualifier', bCompetitor.qualifier()),
      'abbreviation': bCompetitor.abbreviation() || undefined,
      'country_code': bCompetitor.countryCode() || undefined,
    })),

    'markets': h.bmap(bSportEvent, 'markets', bMarket => ({
      'id': bMarket.id(),
      'specifiers': bMarket.specifiers() || undefined,
      'status': bMarket.status(),
      'state': bMarket.state(),
      'weight': bMarket.weight(),
      'provider': bMarket.provider(),
      'favourite': bMarket.favourite(),
      'timestamp': parseInt(bMarket.timestamp(), 10),
      'extended_specifiers': bMarket.extendedSpecifiers() || undefined,

      'outcomes': h.bmap(bMarket, 'outcomes', bOutcome => ({
        'id': bOutcome.id(),
        'odds': bOutcome.odds() / 100 || undefined,
        'state': bOutcome.state(),
        'active': bOutcome.active(),
        'team': bOutcome.team() || undefined,
        'type': enumDecoder('OutcomeType', bOutcome.type()),
      }))
    })),

    'sport': sports.find(sport => sport.sbId === bSportEvent.sportId() && sport.sbType === 'sport'),
    'category': categories.find(category => category.sbId === bSportEvent.categoryId() && category.sbType === 'category') ??
                sports.find(sport => sport.sbId === bSportEvent.categoryId() && sport.sbType === 'category'),
    'tournament': tournaments.find(tournament => tournament.sbId === bSportEvent.tournamentId()) ??
                  categories.find(category => category.sbId === bSportEvent.tournamentId() && category.sbType === 'tournament') ??
                  sports.find(sport => sport.sbId === bSportEvent.tournamentId() && sport.sbType === 'tournament'),
    'video': bSportEvent.video() || undefined,
    'sportlevel': bSportEvent.sportlevel() || undefined,
    'bigsports': bSportEvent.bigsports() || undefined,
    'stats': bSportEvent.stats() || undefined,
    'dicePlatformId': bSportEvent.dicePlatformId() || undefined,
    'perform': h.bmap(bSportEvent, 'perform', p => ({
      'type': p.type(),
      'assetId': p.assetId(),
      'fixtureId': p.fixtureId(),
      'allowedCountryCodes': p.allowedCountryCodes() || undefined,
    })),

    'tags': h.bmap(bSportEvent, 'tags', tag => tag),

    't_settings': {
      'type': bSportEvent.tSettingsType(),
      'list_t': h.bmap(bSportEvent, 'tSettingsList', l => l),
    },

    'match': (() => {
      const match = h.decodeFlexBufferObject(bSportEvent, 'match')
      match.timestamp = match.timestamp && parseInt(match.timestamp, 10)
      return match
    })(),

    'igame': bSportEvent.iGameEventId()
      ? {
        'eventId': bSportEvent.iGameEventId(),
        'streams': h.bmap(bSportEvent, 'iGameStreams', bStream => ({
          'audioBitRateKbps': bStream.audioBitRateKbps(),
          'controls': bStream.controls(),
          'description': bStream.description(),
          'fixedSize': bStream.fixedSize(),
          'fullscreen': bStream.fullscreen(),
          'geoCountryAllow': bStream.geoCountryAllow() || null,
          'geoCountryBlock': bStream.geoCountryBlock(),
          'playerHeight': bStream.playerHeight(),
          'playerWidth': bStream.playerWidth(),
          'streamHeight': bStream.streamHeight(),
          'streamStretching': bStream.streamStretching(),
          'streamType': bStream.streamType(),
          'streamWidth': bStream.streamWidth(),
          'uniqueStreamName': bStream.uniqueStreamName(),
          'videoBitRateKbps': bStream.videoBitRateKbps(),
        }))
      }
      : undefined,

    'extra': {
      'product_info': {
        'is_in_hosted_statistics': bSportEvent.extraIsInHostedStatistics(),
        'is_in_live_match_tracker': bSportEvent.extraIsInLiveMatchTracker(),
        'is_in_live_score': bSportEvent.extraIsInLiveScore(),
        'links': {
          'link': {
            'name': bSportEvent.extraLinkName(),
            'ref': bSportEvent.extraLinkRef(),
          }
        }
      }
    },

    'topEventType': enumDecoder('SportEventTopType', bSportEvent.topEventType()),
    'customSportId': bSportEvent.customSportId() || null,
    'customCategoryId': bSportEvent.customCategoryId() || null,
    'customTournamentId': bSportEvent.customTournamentId() || null,

    'avbetradar': bSportEvent.avbetradarId() ? {
      'id': bSportEvent.avbetradarId(),
      'streams': h.bmap(bSportEvent, 'avbetradarStreams', bStream => ({
        'id': bStream.id(),
        'product': {
          'id': bStream.productId(),
          'name': bStream.productName(),
        },
        'start_time': bStream.startTime(),
        'stream_status': {
          'id': bStream.streamStatusId(),
          'name': bStream.streamStatusName(),
        },
      }))
    }: undefined
  }))

  return {
    sportEvents,
    sports,
    categories,
    tournaments,
  }
}
